import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import reportService from "../../services/ReportService";

export const fetchReport = createAsyncThunk(
  "report/downloadReport",
  async (
    { suiteId, reportType }: { suiteId: number; reportType: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await reportService.downloadReport(suiteId, reportType);
      return response;
    } catch (error: any) {
      console.error("Error fetching report: ", error);
      return rejectWithValue(error.response?.data || "Failed to fetch report");
    }
  }
);
export const fetchCaseReport = createAsyncThunk(
  "report/downloadCaseReport",
  async (caseId: number, { rejectWithValue }) => {
    try {
      const response = await reportService.downloadCaseReport(caseId);
      return response;
    } catch (error: any) {
      console.error("Error fetching case report: ", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch case report"
      );
    }
  }
);
export const fetchReportStructure = createAsyncThunk(
  "report/getCaseReportStructure",
  async (caseId: number, { rejectWithValue }) => {
    try {
      const response = await reportService.getCaseReportStructure(caseId);
      return response.data;
    } catch (error: any) {
      console.error("Error fetching report structure: ", error);
      return rejectWithValue(error || "Failed to fetch report structure");
    }
  }
);
export const fetchReportFile = createAsyncThunk(
  "report/getCaseReportFile",
  async (
    { caseId, path }: { caseId: number; path: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await reportService.getCaseReportFile(caseId, path);
      return response.data;
    } catch (error: any) {
      console.error("Error fetching report file: ", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch report file"
      );
    }
  }
);
export const fetchReportAnalytics = createAsyncThunk(
  "report/getReportAnalytics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await reportService.getReportAnalytics();
      return response.data;
    } catch (error: any) {
      console.error("Error fetching report analytics: ", error);
      return rejectWithValue(error || "Failed to fetch report analytics");
    }
  }
);

export const fetchAllureSingleReport = createAsyncThunk(
  "report/getAllureSingleReport",
  async (
    {
      userId,
      suiteId,
      caseId,
    }: { userId: number; suiteId: number; caseId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await reportService.getAllureSingleReport(
        userId,
        suiteId,
        caseId
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching allure single report: ", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch allure single report"
      );
    }
  }
);

export const fetchAllureGeneralReport = createAsyncThunk(
  "report/getAllureGeneralReport",
  async (
    {
      suiteId,
      userId,
      regenerate,
    }: { suiteId: number; userId: number; regenerate: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await reportService.getAllureGeneralReport(
        suiteId,
        userId,
        regenerate
      );
      return response.data;
    } catch (error: any) {
      console.error("Error fetching allure general report: ", error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch allure general report"
      );
    }
  }
);
